import * as profileEvents from "../../store/events/profile";
import BasicModal from "../Modal/BasicModal";
import Box from "@mui/material/Box";
import Button from "../../components/Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { IconChevronRight } from "../../views/HomeView";
import { InvalidInfo } from "./ContactInfo/ContactInfoList";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import PendingInbox from "../Loading/PendingInbox";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import useNavigateQSA from "../../utils/hooks/useNavigateQSA";
import { useTheme } from "@mui/material";
import ErrorMessages, { ERROR_MESSAGE_TYPE_DEFAULT } from "../ErrorMessages/ErrorMessages";
import {
	Form,
	format,
	isArray,
	isArrayOfLength,
	isObject
} from "@pheaa/channels-component-library";
import {
	INBOX_ITEM_TYPE_DOCUMENT,
	INBOX_ITEM_TYPE_NOT_FOUND,
	INBOX_ITEM_TYPE_REPRINT,
	INBOX_ITEM_TYPE_TAX_SUMMARY,
	getErrorMessageForCode
} from "../../config/common";

const IconPDF = props => {
	return (
		<SvgIcon fill="none" sx={{ height: "32px", marginTop: "5px", width: "25px" }} viewBox="0 0 25 32" {...props}>
			<path d="M16.25 3.16162H5.02C3.9 3.16162 3 4.07162 3 5.18162V26.1516C3 27.2616 3.9 28.1616 5.02 28.1616H21.14C22.27 28.1616 23.16 27.2616 23.16 26.1516V10.0816L16.25 3.16162Z" fill="white" />
			<path d="M16.25 3.16162H5.02C3.9 3.16162 3 4.07162 3 5.18162V26.1516C3 27.2616 3.9 28.1616 5.02 28.1616H21.14C22.27 28.1616 23.16 27.2616 23.16 26.1516V10.0816L16.25 3.16162ZM16.25 5.28162L21.04 10.0816H17.52C16.82 10.0816 16.25 9.51162 16.25 8.81162V5.28162ZM21.66 26.1516C21.66 26.4416 21.43 26.6616 21.14 26.6616H5.02C4.73 26.6616 4.5 26.4316 4.5 26.1516V5.18162C4.5 4.90162 4.73 4.66162 5.02 4.66162H14.75V8.81162C14.75 10.3316 15.99 11.5816 17.52 11.5816H21.66V26.1516Z" fill="#D0021B" />
			<path d="M10.4798 14.9817C10.4798 15.5917 10.2898 16.0617 9.89979 16.3917C9.50979 16.7217 8.96979 16.8817 8.25979 16.8817H7.73978V18.9117H6.52979V13.2017H8.34979C9.03979 13.2017 9.56979 13.3517 9.92979 13.6517C10.2898 13.9517 10.4698 14.3917 10.4698 14.9817H10.4798ZM7.74979 15.8917H8.14979C8.51979 15.8917 8.79978 15.8217 8.98978 15.6717C9.17979 15.5217 9.26979 15.3117 9.26979 15.0317C9.26979 14.7517 9.18979 14.5417 9.03979 14.4017C8.88979 14.2617 8.63979 14.2017 8.30979 14.2017H7.75979V15.9017L7.74979 15.8917Z" fill="#D0021B" />
			<path d="M15.8098 16.0017C15.8098 16.9417 15.5398 17.6617 15.0098 18.1617C14.4798 18.6617 13.6998 18.9117 12.6898 18.9117H11.0698V13.2017H12.8598C13.7898 13.2017 14.5198 13.4517 15.0298 13.9417C15.5398 14.4317 15.7998 15.1217 15.7998 16.0017H15.8098ZM14.5498 16.0317C14.5498 14.8017 14.0098 14.1917 12.9298 14.1917H12.2898V17.9117H12.8098C13.9798 17.9117 14.5598 17.2817 14.5598 16.0317H14.5498Z" fill="#D0021B" />
			<path d="M17.8702 18.9117H16.6802V13.2017H19.9502V14.1917H17.8702V15.6617H19.8102V16.6517H17.8702V18.9117Z" fill="#D0021B" />
		</SvgIcon>
	);
};

const TaxDocumentsList = props => {

	let listElem = null;

	const {
		getInboxDocumentById,
		getTaxSummaryById,
		inbox,
		inboxDocuments,
		inboxErrors,
		inboxIsLoading,
		inboxTaxSummaries,
		maxListItems = 0
	} = props;

	const navigate = useNavigateQSA();
	const theme = useTheme();
	const [isViewingReprint, setIsViewingReprint] = React.useState(false);

	const inboxList = isArray(inbox) ? inbox
		.filter((inboxItem, index) => inboxItem.type !== INBOX_ITEM_TYPE_NOT_FOUND)
		.filter((inboxItem, index) => (maxListItems > 0 ? index < maxListItems : true)) : [];

	if (isArrayOfLength(inboxList)) {
		listElem = (
			<nav aria-label={`Most Recent Documents (${maxListItems})`}>

				<BasicModal
					onClose={() => {
						setIsViewingReprint(false);
					}}
					open={isViewingReprint}
					style={{
						borderRadius: 1,
						maxWidth: 480,
						width: "100%"
					}}
				>
					<Box align="right">
						<IconButton
							align="right"
							color="primary"
							onClick={() => { setIsViewingReprint(false); }}
							sx={{
								justifySelf: "end",
								padding: 0
							}}
						>
							<CloseIcon fontSize="large" />
						</IconButton>
					</Box>
					<Typography component="h1" mb={2} variant="h5">Update in Progress</Typography>
					<Typography>
						Your tax form is being updated. Please try again later if you wish to view your tax form.
					</Typography>
					<Form
						id="defaultForm"
						onSubmit={() => { setIsViewingReprint(false); }}
					>
						<Box mt={5.625}>
							<Button
								type="submit"
								variant="contained"
							>
								Close
							</Button>
						</Box>
					</Form>
				</BasicModal>
				<List disablePadding>
					{
						inboxList.map((inboxItem, i) => {

							if (inboxItem.type === INBOX_ITEM_TYPE_DOCUMENT && isObject(inboxDocuments[inboxItem.id])) {
								inboxItem = { ...inboxItem, ...inboxDocuments[inboxItem.id] };
							}

							const handleClick = e => {

								if (inboxItem.type === INBOX_ITEM_TYPE_DOCUMENT) {
									getInboxDocumentById(inboxItem.id, inboxItem.mimeType);
								} else if (inboxItem.type === INBOX_ITEM_TYPE_TAX_SUMMARY) {
									isObject(inboxTaxSummaries) && !isObject(inboxTaxSummaries[inboxItem.id]) && getTaxSummaryById(inboxItem.id);
									navigate({ pathname: `/inbox/tax-summary/${inboxItem.id}` });
								} else if (inboxItem.type === INBOX_ITEM_TYPE_REPRINT) {
									setIsViewingReprint(true);
								}
							};

							return (
								<ListItem disablePadding key={i}>
									<ListItemButton
										onClick={handleClick}
										sx={{
											alignItems: "center",
											borderBottom: `1px solid ${theme.palette.neutral.main}`,
											justifyContent: "flex-end",
											minHeight: 80
										}}
									>
										<Box sx={{
											alignItems: "center",
											display: "grid",
											gridGap: "0.8rem",
											gridTemplateColumns: "1fr max-content min-content",
											width: "100%"
										}}>
											<Box
												sx={{
													alignItems: "center",
													display: "grid",
													fontWeight: 700,
													gridTemplateColumns: "auto min-content"
												}}
												title={inboxItem.subject}
											>
												<Box>
													{inboxItem.subject}
												</Box>
												{inboxItem.mimeType === "application/pdf" && <IconPDF sx={{ marginLeft: 0.5, marginTop: 0.8 }} />}
											</Box>
											<Box
												sx={{
													flex: "0 1 auto",
													textAlign: "right"
												}}
											>
												<Box>
													{format.asDate(inboxItem.deliveryDate, { outputPattern: "mm dd, yyyy" })}
												</Box>
												{
													inboxItem.isLoading && (
														<Box>
															Processing...
														</Box>
													)
												}
												{
													isArrayOfLength(inboxItem.errors) && (
														<Box>
															<InvalidInfo sx={{ marginRight: 0 }} text="Unexpected error occurred. Please try again." />
														</Box>
													)
												}
											</Box>
											<Box pt={0.5}><IconChevronRight /></Box>
										</Box>
									</ListItemButton>
								</ListItem>
							);
						})
					}
				</List>
			</nav>
		);
	} else if (inboxIsLoading) {
		listElem = <PendingInbox />;
	} else if (isArrayOfLength(inboxErrors)) {
		listElem = (
			<ErrorMessages
				errorMessages={inboxErrors.map(err => {
					return {
						id: err.code,
						message: getErrorMessageForCode(err.code),
						type: ERROR_MESSAGE_TYPE_DEFAULT
					};
				})}
			/>
		);
	} else if (isArray(inboxList)) {
		listElem = (
			<Box flex={1} px={3} py={3}>
				<Typography textAlign="center">
					You currently have no tax documents.
				</Typography>
			</Box>
		);
	}

	return listElem;
};

const mapStateToProps = state => ({
	inbox: state.profile.inbox,
	inboxDocuments: state.profile.inboxDocuments,
	inboxErrors: state.profile.inboxErrors,
	inboxIsLoading: state.profile.inboxIsLoading,
	inboxTaxSummaries: state.profile.inboxTaxSummaries
});

const mapDispatchToProps = dispatch => ({
	getInboxDocumentById: (documentId, mimeType) => dispatch(profileEvents.getInboxDocumentById(documentId, mimeType)),
	getTaxSummaryById: data => dispatch(profileEvents.getTaxSummaryById(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxDocumentsList);